import { render, staticRenderFns } from "./infoIcon.vue?vue&type=template&id=f6718aa8&"
import script from "./infoIcon.vue?vue&type=script&lang=js&"
export * from "./infoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports